module.exports = __webpack_public_path__ + "img/4927407616e7bdca896263ff609ec00a.png";